import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E2E8F0", color: "#0F172A", fontSize: "12px", boxShadow: "0 4px 12px rgba(15,23,42,0.08)" } }} />
    </div>
  );
}

export default App;
